import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icon/amway-cc-logo-b.svg'
import _imports_1 from '@/assets/icon/amway-cc-logo-m.svg'
import _imports_2 from '@/assets/images/sorry.svg'
import _imports_3 from '@/assets/icon/icon-roadmap.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-area desktop" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Amway Creator Challenge"
}, null, -1)
const _hoisted_4 = { class: "header-area mobile" }
const _hoisted_5 = { class: "header-logo-area" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Amway Creator Challenge"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<section class=\"register-fail\"><div class=\"container\"><div class=\"rf-content\"><h2 class=\"rf-title\">ขออภัยค่ะ</h2><img src=\"" + _imports_2 + "\" alt=\"sorry\" class=\"rf-image\"><p class=\"rf-text\"> คุณไม่ได้เข้าร่วมการแข่งขัน Creators Challenge <br>พบกันใหม่ในกิจกรรมถัดไป </p><a href=\"https://amway.co.th\" class=\"btn-red\"><div><img src=\"" + _imports_3 + "\" style=\"width:32px;height:32px;margin-right:12px;\">กลับเว็บไซต์หลัก </div></a></div></div></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: _ctx.dayjs().isSameOrAfter('2022-03-05') ? '/activity' : '/challenge',
          class: "header-logo"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: _ctx.dayjs().isSameOrAfter('2022-03-05') ? '/activity' : '/challenge',
            class: "header-logo"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ]),
    _hoisted_7
  ], 64))
}